export enum TransactionType {
    Payment,
    Recharge,
    Discharge,
    Reversal,
    SecurityDeposit,
    DebtPayoff,
    CreditCardBalanceTransfer
}


// WEBPACK FOOTER //
// ./src/app/models/TransactionType.ts